export const SYNCHRONIZATION_ERROR_CODES = {
  PORTAL_CREDENTIALS_REQUIRED: '/synchronization/portal-credentials-required',
  PORTAL_CREDENTIALS_INVALID: '/synchronization/portal-credentials-invalid',
} as const;
